import type { CSSObject, Theme as MuiTheme } from '@mui/material';
import _ from 'lodash';
import type { ApplyStyles, ThemeMode } from '../types';

export function createUtils(theme: MuiTheme) {
  return {
    applyStyles: (
      ...args: [...ThemeMode[], Record<string, any>]
    ): CSSObject => {
      const modes = args.slice(0, -1);
      const styles = args[args.length - 1];

      return _.merge(
        {},
        ...modes.map((mode) => {
          // @ts-expect-error - we are override the type of applyStyles to allow for multiple modes
          return theme.applyStyles(mode, styles);
        })
      );
    },
  };
}

declare module '@mui/material' {
  interface Theme {
    applyStyles: ApplyStyles;
  }
}
